import { Check, Plus } from "lucide-react";

function InlineToggle({ active, label, onClick, slug }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`group inline-flex items-center gap-2 text-[13px] font-medium transition-colors duration-200 ${active ? "text-[#1D3F94]" : "text-[#6e6e73] hover:text-[#1D3F94]"}`}
      data-testid={`compare-toggle-${slug}`}
    >
      <span className={`w-4 h-4 rounded-[5px] border flex items-center justify-center transition-colors duration-200 ${active ? "bg-[#1D3F94] border-[#1D3F94] text-white" : "border-[#c7c7cc] group-hover:border-[#1D3F94]"}`}>
        {active && <Check size={11} strokeWidth={3} />}
      </span>
      {label}
    </button>
  );
}
import { useLang } from "../lang";
import { useCompare } from "./CompareContext";

export default function CompareButton({ slug, variant = "chip" }) {
  const { lang } = useLang();
  const { slugs, toggle } = useCompare();
  const active = slugs.includes(slug);
  const label = active ? (lang === "it" ? "Nel confronto" : "Comparing") : (lang === "it" ? "Confronta" : "Compare");
  const onClick = (e) => { e.preventDefault(); e.stopPropagation(); toggle(slug, lang); };
  if (variant === "inline") return <InlineToggle active={active} label={label} onClick={onClick} slug={slug} />;
  const base = variant === "chip"
    ? "px-3 py-1.5 text-[12px] shadow-sm backdrop-blur-sm"
    : "px-4 py-2 text-[14px] border";
  const colors = active
    ? "bg-[#1D3F94] text-white border-[#1D3F94]"
    : variant === "chip" ? "bg-white/90 text-[#1d1d1f] hover:bg-white" : "bg-white text-[#1D3F94] border-[#1D3F94]/30 hover:border-[#1D3F94]";
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium transition-colors duration-200 ${base} ${colors}`}
      data-testid={`compare-toggle-${slug}`}
    >
      {active ? <Check size={14} /> : <Plus size={14} />}
      {label}
    </button>
  );
}
